module.exports = __webpack_public_path__ + "static/image-woman-45f5f1a5d29be05fb1560d8229908b16.jpg";